

















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class ButtonInput extends Vue {
  // noinspection JSUnusedGlobalSymbols
  $event!: Event;

  @Prop() id!: string;
  @Prop() label!: string;
  @Prop() type!: string;
  @Prop() shifted!: boolean;
  @Prop() highlighted!: boolean;
  @Prop() disabled!: boolean;

  get classObject(): object {
    return {
      inputButton: this.type !== 'keyboardKey',
      primaryButton: !this.type || this.type === 'primary',
      secondaryButton: this.type === 'secondary',
      keyboardKey: this.type === 'keyboardKey',
      highlighted: this.highlighted,
      disabled: this.disabled,
    };
  }
}
